import {ResourceConfig} from "@hidat/huijs-resource";
import {LibraryBaseFields, LibraryBaseInterface} from "./library-base.interface";
import {AnyHash, FieldConfig, FieldDataTypes, uBoolean, uNumber, uString} from "@hidat/huijs-common";

export const CatalogConfig = new ResourceConfig('Catalog', 'catalogs', true, true)
  .addFields(LibraryBaseFields)
  .addFields([
    new FieldConfig('trackChanges', FieldDataTypes.BOOLEAN),
    new FieldConfig('trackRotationStatus', FieldDataTypes.BOOLEAN),
    new FieldConfig('hasSchedulingMeta', FieldDataTypes.BOOLEAN),

  ])
  .setSorts({
    name: 'name'
  })
  .setDefaultSort('name');

export interface CatalogInterface extends LibraryBaseInterface {
  trackChanges: uBoolean;
  trackRotationStatus: uBoolean;
  hasSchedulingMeta: uBoolean;

}
